import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Button, Typography } from '@mui/material';
import TaskSpaceDesigner from 'components/wkf/components/TaskSpaceDesigner';
import { setProductassetViewModal, updateProductObj } from 'store/slice/PharmaSlice';
import ViewActionModal from 'components/productasset/action/view/ViewActionModal';
import TaskSpaceQA from 'components/wkf/components/TaskSpaceQA';
import { rejectTaskAPI, completeTaskAPI } from 'api/CorePlatformserviceWebServices';
import MuiAlert from '@mui/material/Alert';
import { initRefreshTaskList, setTaskConfirmationMsg } from 'store/slice/AppSlice';
import TaskSpaceDesignerPlaceOrder from 'components/wkf/components/TaskSpaceDesignerPlaceOrder';
import RmmanagementActionImpl from 'components/product/action/rmmanagement/RmmanagementActionImpl';
import TaskSpaceRM from 'components/wkf/components/TaskSpaceRM';
import TaskSpaceStore from 'components/wkf/components/TaskSpaceStore';
import TaskSpaceRMReceive from 'components/wkf/components/TaskSpaceRMReceive';
import TaskSpaceProd from 'components/wkf/components/TaskSpaceProd';
import TaskSpaceQaMaterialCheck from 'components/wkf/components/TaskSpaceQaMaterialCheck';
import { setCommentList, setTaskApiResponse, setTaskApiResponseError } from 'store/slice/AppSlice';
import { callGetAPI } from 'api/ApiUtils';
import TaskSpaceProdMaterialRevise from 'components/wkf/components/TaskSpaceProdMaterialRevise';
import TaskSpaceProdPackaging from 'components/wkf/components/TaskSpaceProdPackaging';
import TaskSpacePackaging from 'components/wkf/components/TaskSpacePackaging';
import TaskSpaceDispatch from 'components/wkf/components/TaskSpaceDispatch';
import { setTaskCompleted } from 'store/slice/AppSlice';
import TaskSpaceAccountsDispatchApproval from 'components/wkf/components/TaskSpaceAccountsDispatchApproval';
import TaskSpaceMD from 'components/wkf/components/order-apporval/TaskSpaceMD';
import TaskSpaceSalesRevisePo from 'components/wkf/components/order-apporval/TaskSpaceSalesRevisePo';
import TaskSpaceAccounts from 'components/wkf/components/order-apporval/TaskSpaceAccounts';
import TaskSpaceProdGranulation from 'components/wkf/components/TaskSpaceProdGranulation';
import TaskSpaceProdFilling from 'components/wkf/components/TaskSpaceProdFilling';
import TaskSpaceProdPrimaryPackaging from 'components/wkf/components/TaskSpaceProdPrimaryPackaging';
import TaskSpaceSalesRevisePoForQAFeedback from 'components/wkf/components/order-apporval/TaskSpaceSalesRevisePoForQAFeedback';
import TaskSpaceOrderApprovalQA from 'components/wkf/components/order-apporval/TaskSpaceOrderApprovalQA';
import TaskSpaceQAPMqualityCheck from 'components/wkf/components/TaskSpaceQAPMqualityCheck';
import TaskSpaceDesignerRevisePM from 'components/wkf/components/TaskSpaceDesignerRevisePM';
import TaskSpaceQAReleaseCheck from 'components/wkf/components/TaskSpaceQAReleaseCheck';
import TaskSpaceTaskConfirmation from 'components/wkf/components/common/TaskSpaceTaskConfirmation';
import { CircularProgress } from '@mui/material';
import TaskSpacePageMobile from 'components/wkf/page/TaskSpacePageMobile';
import TaskSpaceDesignerReviseDesign from 'components/wkf/components/TaskSpaceDesignerReviseDesign';
import TaskSpaceProdUpdateSetAndColor from 'components/wkf/components/TaskSpaceProdUpdateSetAndColor';
import TaskSpaceStoreStockCheck from 'components/wkf/components/TaskSpaceStoreStockCheck';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {getAPI as getProductAPI} from 'components/product/ProductAPI';
import TaskSpaceSalesCustomerDesign from 'components/wkf/components/TaskSpaceSalesCustomerDesign';

export default function HandleTaskActionImpl() {
  const dispatch = useDispatch();
  const {mobileView} = useSelector((state) => state.menu);
  const { selectedTaskObj, referbackTaskButtonEnabled, completeTaskButtonEnabled, taskApiResponse, taskApiResponseError, hideTaskActionBar } = useSelector((state) => state.appslice.wkflow);
  const { initRefreshCommentList } = useSelector(state => state.appslice.wkflow);
  const { checkRejectCondtion } = useSelector(state => state.appslice.wkflow);
  const [apiInProgress, setApiInProgress] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [referBackConfirmOpen, setReferBackConfirmOpen] = useState(false);

  useEffect(() => {
    dispatch(setTaskApiResponse(null));
    dispatch(setTaskApiResponseError(""));
    dispatch(setTaskCompleted(false));

    // Load Product Object fresh
    getProductAPI(selectedTaskObj.boobjid, (response) => {
      dispatch(updateProductObj(response));
    });

  }, []);

  useEffect(() => {
    if (taskApiResponse && taskApiResponse.success) dispatch(setTaskCompleted(true));
    else dispatch(setTaskCompleted(false));
    
  },[taskApiResponse]);

  useEffect(() => {
    getCommentList();
  }, [initRefreshCommentList]);
  useEffect(() => {
    console.log("Complete Task Button Enabled: ", completeTaskButtonEnabled);
  },[completeTaskButtonEnabled]);

  useEffect(() => {
    //  if (taskApiResponse && taskApiResponse.success){
    //   // Fetch Product Object to update the product Obj
    //     getProductAPI(selectedTaskObj.boobjid, (response) => {
    //     dispatch(updateProductObj(response));
    //   }, (error) => {
    //     console.error("Error fetching product details: ", error);
    //   });

    //  }
  }, [taskApiResponse]);

  const getCommentList = () => {
    callGetAPI("https://api.platform.appmachine.in/comments/boid/" + selectedTaskObj.boobjid + "/boobjid", () => { },
      (response) => {
        dispatch(setCommentList(response));
      }, (error) => {
        console.error("Error fetching comments", error);
      }
    );
  }
  const callApproveTaskAPI = () => {
    dispatch(setTaskApiResponseError(""));
    setApiInProgress(true);
    completeTaskAPI({ taskInstanceId: selectedTaskObj.id }, (response) => {
      console.log("Task completed successfully: ", JSON.stringify(response));
      dispatch(setTaskApiResponse(response));
      dispatch(initRefreshTaskList());
      setApiInProgress(false);
    }, (error) => {
      dispatch(setTaskApiResponseError(error));
      setApiInProgress(false);
    });
  }
  const callRejectTaskAPI = () => {
    dispatch(setTaskApiResponseError(""));
    setApiInProgress(true)
    rejectTaskAPI({ taskInstanceId: selectedTaskObj.id, 'conditionCheck': checkRejectCondtion }, (response) => {
      dispatch(setTaskApiResponse(response));
      dispatch(initRefreshTaskList());
      setApiInProgress(false);
    }, (error) => {
      dispatch(setTaskApiResponseError(error));
      setApiInProgress(false);
    });
  }

  const getTaskProcessor = () => {

    if (selectedTaskObj.taskid === 48 || selectedTaskObj.taskid === 51) {
      return <TaskSpaceDesigner />;
    }  else if (selectedTaskObj.taskid === 52) {
      return <TaskSpaceDesignerReviseDesign />;
    } else if (selectedTaskObj.taskid === 49) {
     // if (mobileView) return <TaskSpacePageMobile />;
      return <TaskSpaceQA />;
    } else if (selectedTaskObj.taskid === 60 || selectedTaskObj.taskid === 113) {
      return <TaskSpaceDesignerPlaceOrder />;
    } else if (selectedTaskObj.taskid === 95) {
      return <TaskSpaceRM />;
    } else if (selectedTaskObj.taskid === 57) {
      return <TaskSpaceRMReceive />;
    } else if (selectedTaskObj.taskid === 67) {
      return <TaskSpaceStore />;
    } else if (selectedTaskObj.taskid === 68 || selectedTaskObj.taskid ===116) {
      return <TaskSpaceProd />;
    } 
    // else if (selectedTaskObj.taskid === 69 || selectedTaskObj.taskid === 102) {
    //   return <TaskSpaceQaMaterialCheck />;
    else if (selectedTaskObj.taskid === 69 || selectedTaskObj.taskid === 102 || selectedTaskObj.taskid === 131 || selectedTaskObj.taskid === 126) {
      dispatch(setTaskConfirmationMsg("I confirm that batch no. & mfg. date and exp. date is OK as per specifications and ready for the production."));
      return <TaskSpaceTaskConfirmation />;
    } else if (selectedTaskObj.taskid === 70 || selectedTaskObj.taskid === 127) {
      dispatch(setTaskConfirmationMsg("I confirm that Batch is revised as per QA feedback and Ready for QA Approval."));
      return <TaskSpaceProdMaterialRevise />;
    } else if (selectedTaskObj.taskid === 104 || selectedTaskObj.taskid === 130) {
      dispatch(setTaskConfirmationMsg("I confirm that Batch is revised as per QC feedback and Ready for QC Approval."));
      return <TaskSpaceProdMaterialRevise />;
    }else if (selectedTaskObj.taskid === 71) {
      return <TaskSpaceProdPackaging />;
    } 
    // else if (selectedTaskObj.taskid === 72) {
    //   return <TaskSpacePackaging />;
    // } 
    
    // else if (selectedTaskObj.taskid === 73) {
    //   return <TaskSpaceDispatch />;
    // }
    // else if (selectedTaskObj.taskid === 76) {
    //   return <TaskSpaceAccountsDispatchApproval />;
    // }
    else if (selectedTaskObj.taskid === 79) {
      return <TaskSpaceMD />;
    }else if (selectedTaskObj.taskid === 81) {
      return <TaskSpaceSalesRevisePo />;
    }else if (selectedTaskObj.taskid === 80) {
      return <TaskSpaceAccounts />;
    }else if (selectedTaskObj.taskid === 77) {
      return <TaskSpaceProdGranulation />;
    }else if (selectedTaskObj.taskid === 78) {
      return <TaskSpaceProdFilling />;
    } else if (selectedTaskObj.taskid === 93) {
      return <TaskSpaceProdPrimaryPackaging />;
    } else if (selectedTaskObj.taskid === 97) {
      return <TaskSpaceSalesRevisePoForQAFeedback />;
    }else if (selectedTaskObj.taskid === 96) {
      return <TaskSpaceOrderApprovalQA />;
    }
    // else if (selectedTaskObj.taskid === 98) {
    //   return <TaskSpaceQAReleaseCheck />;
    // }
    // else if (selectedTaskObj.taskid === 99) {
    //   return <TaskSpaceQAPMqualityCheck />;
    // }
    else if (selectedTaskObj.taskid === 100) {
      return <TaskSpaceDesignerRevisePM />;
    }
    else if (selectedTaskObj.taskid === 105) {
      dispatch(setTaskConfirmationMsg("I confirm that Compression is Complete and Product is ready for Batch Approval"));
      return <TaskSpaceTaskConfirmation />;
    }
     else if (selectedTaskObj.taskid === 106) {
      dispatch(setTaskConfirmationMsg("I confirm that Primary Packaging is Complete as per Customer requirement."));
      return <TaskSpaceTaskConfirmation />;
    }else if (selectedTaskObj.taskid === 107) {
      dispatch(setTaskConfirmationMsg("I confirm that Primary Packaging is revised as per QA feedback and Ready for QA Approval."));
      return <TaskSpaceProdMaterialRevise />;
    }
    else if (selectedTaskObj.taskid === 108 || selectedTaskObj.taskid === 99) {
      dispatch(setTaskConfirmationMsg("I confirm that packaging material is OK as per specification and now primary packaging can start."));
      return <TaskSpaceTaskConfirmation />;
    }else if (selectedTaskObj.taskid === 117) {
      dispatch(setTaskConfirmationMsg("I confirm that QA Test for this product is passed."));
      return <TaskSpaceTaskConfirmation />;
    }else if (selectedTaskObj.taskid === 120) {
      dispatch(setTaskConfirmationMsg("I confirm that QC Test for this product is passed."));
      return <TaskSpaceTaskConfirmation />;
    }
    else if (selectedTaskObj.taskid === 125) {
      dispatch(setTaskConfirmationMsg("I confirm that Primary Packaging is Complete and it is ready for QA Approval"));
      return <TaskSpaceTaskConfirmation />;
    }
    else if (selectedTaskObj.taskid === 109) {
      dispatch(setTaskConfirmationMsg("I confirm that Primary Packaging is revised as per QC feedback and Ready for QC Approval."));
      return <TaskSpaceProdMaterialRevise />;
    }else if (selectedTaskObj.taskid === 114 || selectedTaskObj.taskid === 139) {
      return <TaskSpaceProdUpdateSetAndColor />;
    } else if (selectedTaskObj.taskid === 112) {
      return <TaskSpaceStoreStockCheck />;
    }else if (selectedTaskObj.taskid === 98) {
      dispatch(setTaskConfirmationMsg("I confirm that Product is Ready for Packaging."));
      return <TaskSpaceTaskConfirmation />;
    }else if (selectedTaskObj.taskid === 72) {
      dispatch(setTaskConfirmationMsg("I confirm that Packaging of the Product is complete. Now, it is ready for Dispatch."));
      return <TaskSpaceTaskConfirmation />;
    }
    else if (selectedTaskObj.taskid === 76) {
      dispatch(setTaskConfirmationMsg("I confirm that Payment Terms of this product are Satisfied and Account is OK to dispatch this product."));
      return <TaskSpaceTaskConfirmation />;
    }else if (selectedTaskObj.taskid === 73) {
      dispatch(setTaskConfirmationMsg("I confirm that this product is dispatched to Customer."));
      return <TaskSpaceTaskConfirmation />;
    }
    else if (selectedTaskObj.taskid === 141) {
      dispatch(setTaskConfirmationMsg("I confirm that I have resolved Accounts comments and now Accounts can again review it."));
      return <TaskSpaceTaskConfirmation />;
    }
    // else if (selectedTaskObj.taskid === 140) {
    //   return <TaskSpaceSalesCustomerDesign />;
    // }

    else if (selectedTaskObj.taskid === 140) {
      dispatch(setTaskConfirmationMsg("I confirm that I have arranged DESIGN to designer to proceed further."));
      return <TaskSpaceTaskConfirmation />;
    }

    
    
  
  }
  const getCompleteTaskButtonLabel = () => {
    if (selectedTaskObj.taskid === 80) {
      return "Advance Payment Received";
    } else if (selectedTaskObj.taskid === 79) {
      return "Approve & Submit to Accounts";
    } else {
      return "Complete Task";
    }
  }
  const handleApproveClick = () => {
    setConfirmOpen(true);
  };

  const handleConfirmApprove = () => {
    setConfirmOpen(false);
    callApproveTaskAPI();
  };

  const handleCancelApprove = () => {
    setConfirmOpen(false);
  };

  const handleReferBackClick = () => {
    setReferBackConfirmOpen(true);
  };

  const handleConfirmReferBack = () => {
    setReferBackConfirmOpen(false);
    callRejectTaskAPI();
  };

  const handleCancelReferBack = () => {
    setReferBackConfirmOpen(false);
  };

  return (
    <>
      <Grid container sx={{ width: '100%', height: '100%' }} direction="column" justifyContent="flex-start" alignItems="center">
        <Grid item lg={12} xs={12} sx={{ width: '100%', maxHeight: {xs:'92vh',lg:'98vh', sm:'98vh', 'md':'98vh'}, overflowY: 'auto' }}>
          {getTaskProcessor()}
        </Grid>
        
        {!hideTaskActionBar && (
          <Grid item lg={12} xs={12} sx={{ width: '100%',    borderRadius: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center',  }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
              
              <Grid item lg={8} xs={12} sx={{ flexGrow: 1,pl:{lg:2} }}>
                    {taskApiResponseError && (
                      
                        <MuiAlert severity="error" sx={{ width: "100%", backgroundColor:'red', color:'white' }}>
                          {taskApiResponseError}
                        </MuiAlert>
                    
                    )}
              </Grid>
              {apiInProgress? <><CircularProgress /></> :
            <Grid item lg={4} xs={12} sx={{ flexGrow: 1,  pt:{xs:1} }}>
                {taskApiResponse ? (
                  
                    <MuiAlert severity="success" sx={{ width: "100%" }}>
                      {typeof taskApiResponse === "string"
                        ? taskApiResponse
                        : "Task completed successfully."}
                    </MuiAlert>
                  
                ) 
                : (
                 <Grid container justifyContent="flex-end" alignItems="center" sx={{ width: '100%',pb:1 }}>
                  {selectedTaskObj.rejectedtaskid !== 0 && (
                    <Grid item>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleReferBackClick}
                        disabled={!referbackTaskButtonEnabled}
                        sx={{ minWidth: 140, ml: 2 }}
                      >
                        Refer Back
                      </Button>
                    </Grid>
                  )}
                  <Grid item sx={{ ml: 2 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleApproveClick}
                      disabled={!completeTaskButtonEnabled || completeTaskButtonEnabled==="false"}
                      sx={{ minWidth: 140 }}
                    >
                      {getCompleteTaskButtonLabel()}
                    </Button>
                  </Grid>
                </Grid>
                
              )}
              </Grid>
               }
            </Grid>
          </Grid>)}
      </Grid>
      <ViewActionModal />

      {/* Confirmation Dialog */}
      <Dialog open={confirmOpen} onClose={handleCancelApprove}>
        <DialogTitle>Confirm Task Completion</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to complete this task?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelApprove} color="secondary">Cancel</Button>
          <Button onClick={handleConfirmApprove} color="primary" variant="contained">Confirm</Button>
        </DialogActions>
      </Dialog>

      {/* Refer Back Confirmation Dialog */}
      <Dialog open={referBackConfirmOpen} onClose={handleCancelReferBack}>
        <DialogTitle>Confirm Refer Back</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to refer back this task?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelReferBack} color="secondary">Cancel</Button>
          <Button onClick={handleConfirmReferBack} color="primary" variant="contained">Confirm</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}